import { IEstimator } from '@abrController/Estimators/IEstimator';
import { IInsufficientBufferEstimatorConfig } from '@abrController/Estimators/InsufficientBufferEstimator/InsufficientBufferEstimator.config';
import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { EDebuggableModuleState, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';
import { IResolution } from '@resolutionsManager/IResolutionsManager';

export class InsufficientBufferEstimator extends ConfigConsumer<IInsufficientBufferEstimatorConfig> implements IEstimator {
  public status: string = 'Idle';
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public groups: string[] = ['abr'];
  public additionalInfo: TDebuggableAdditionalInfo = {};

  private _hasPassedMinimalBuffer: boolean = false;

  constructor(eventBus: TEventBus) {
    super('insufficientBufferEstimator', eventBus);
  }

  destroy(): void {
    super.destroy();
  }

  reset(): void {
    this._hasPassedMinimalBuffer = false;
  }

  public getNextEstimatedResolution(
    availableDecreasingResolutions: IResolution[],
    currentResolution: IResolution | null,
    metrics: IBufferMetrics,
  ): IResolution | null {
    const isBufferExceedsMinimal: boolean = metrics.bufferAmount > this.config.minimalBufferAmount;

    if (!this._hasPassedMinimalBuffer && isBufferExceedsMinimal) {
      this._hasPassedMinimalBuffer = true;
    }

    const isResultsConfident: boolean = !this.config.ignoreMetricsBeforeBufferExceedsMinimal || this._hasPassedMinimalBuffer;

    this.additionalInfo.isResultsConfident = isResultsConfident;
    this.additionalInfo.isBufferExceedsMinimal = isBufferExceedsMinimal;
    this.additionalInfo.hasPassedMinimalBuffer = this._hasPassedMinimalBuffer;

    if (!isResultsConfident || isBufferExceedsMinimal || !currentResolution) {
      return null;
    }

    this._hasPassedMinimalBuffer = false;

    const smallestResolution: IResolution = availableDecreasingResolutions.slice(-1)[0];
    const smallerResolution: IResolution =
      currentResolution.url === smallestResolution.url
        ? currentResolution
        : availableDecreasingResolutions[availableDecreasingResolutions.findIndex(({ name }) => name === currentResolution.name) + 1];

    return this.config.switchToMinimalResolution ? smallestResolution : smallerResolution;
  }

  public _handleConfigUpdated(): void {
    this._hasPassedMinimalBuffer = false;
  }
}
